import { Typography } from '@material-ui/core'
import { Skeleton } from '@material-ui/lab'

import useStyles from './styles/ReferenceRow'

export const ReferenceRowSkeleton = () => {
  const classes = useStyles()

  return (
    <div className={classes.root}>
      <Typography variant="body1">
        <Skeleton animation="wave" className={classes.skeleton} />
      </Typography>
      <Typography variant="body1">
        <Skeleton animation="wave" className={classes.skeleton} />
      </Typography>
    </div>
  )
}
